import axiosInstance from '../services/AxiosInstance';

export function getUsers(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`user?populate=userRole&pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}&${filterQuery}`);
}

export function getAllUsers(filterQuery = "") {
    return axiosInstance.get(`user?noPagination=true&${filterQuery}`);
}

export function deleteUser(userId) {
    return axiosInstance.delete(`user/${userId}`);
}

export function createUser(userData) {
    return axiosInstance.post(`user`,userData);
}

export function updateUser(userId, userData) {
    return axiosInstance.put(`user/${userId}`,userData);
}
